import { TMasterLanguageTestLevel } from "@/api/entities/master-language-test-level.entity";

// Levels are saved in the order they are submitted, so always display and edit them by `order`
export const sortLanguageTestLevels = (levels: TMasterLanguageTestLevel[] = []) => [...levels].sort((a, b) => a.order - b.order);
